import { useState, useCallback } from "react";

type ModalState = {
  isOpenModal: boolean;
  toggleModal: () => void;
};

/**
 * Custom hook to manage the state of a modal.
 *
 * @returns {Object} An object containing the `isOpenModal` state and the `toggleModal` function.
 * @returns {boolean} isOpenModal - The state of the modal, `true` if it's open, `false` if it's closed.
 * @returns {Function} toggleModal - A function that toggles the modal's state.
 */
export const useToggleModal = (): ModalState => {
  const [isOpenModal, setIsOpen] = useState<boolean>(false);

  const toggleModal = useCallback(() => {
    setIsOpen((prevState) => !prevState);
  }, []);

  return {
    isOpenModal,
    toggleModal,
  };
};
